module.exports = __webpack_public_path__ + "static/TitlecardMapNEW-073d5d3b14f5c383be48142842d40186.png";